import { cn } from '~/lib/utils';
import ErrorIcon from '../icons/ErrorIcon';

interface Props {
  className?: string;
  error: string;
  id?: string;
}

export default function ErrorMessage({ className, error, id }: Props) {
  return (
    <p
      className={cn(
        `text-light bg-red-light-40 border-red-light-40 text-red-dark my-2 flex items-center space-x-1 rounded-lg border p-2 text-sm`,
        className
      )}
      id={id}
      key={error}
    >
      <span>
        <ErrorIcon />
      </span>
      <span>{error}</span>
    </p>
  );
}
